import React, { useState, useEffect } from "react";
import Icon from "./ds/Icon";

export default function Time({
  value,
  onChange,
}) {
  const [hour, setHour] = useState('12');
  const [minute, setMinute] = useState('00');
  const [daytime, setDaytime] = useState('PM');

  useEffect(() => {
    if (value) {
      let time = value.split(' ');
      let hours = time[0].split(':');

      setHour(hours[0]);
      setMinute(hours[1]);
      setDaytime(time[1]);
    }
  }, [value]);

  // Time
  function select(e) {
    e.target.setSelectionRange(0, e.target.value.length);
  }

  function handleKeyDown(e) {
    const key = e.keyCode;

    if ( (key >= 48 && key <= 57) || (key >= 96 && key <= 105) || key == 8 || key == 9 ) {
      return;
    } else {
      e.preventDefault();
    }
  }

  function handleFocus() {
    document.getElementById('time').classList.add('focus');
  }

  const handleChange = (e) => {
    let value = e.target.value;

    if (e.target.name === 'hour') {
      if (value.length == 2) {
        value = value < 1 ? '01' : value;
        value = value > 12 ? '12' : value;

        onChange(`${value}:${minute} ${daytime}`);
      }

      setHour(value);
    } else if (e.target.name === 'minute') {
      if (value.length == 2) {
        value = value > 59 ? '59' : value;

        onChange(`${hour}:${value} ${daytime}`);
      }

      setMinute(value);
    }
  };

  function handleBlur(e) {
    let value = e.target.value;

    if (e.target.name === 'hour') {
      value = value < 1 ? '01' : value;
      value = value > 12 ? '12' : value;
      value = value.padStart(2, '0');

      onChange(`${value}:${minute} ${daytime}`);

      setHour(value);
    } else if (e.target.name === 'minute') {
      value = value > 59 ? '59' : value;
      value = value.padStart(2, '0');

      onChange(`${hour}:${value} ${daytime}`);

      setMinute(value);
    }

    document.getElementById('time').classList.remove('focus');
  }

  // Toggle Daytime
  function toggleDaytime() {
    const newDaytime = daytime == 'AM' ? 'PM' : 'AM';
    setDaytime(newDaytime);

    onChange(`${hour}:${minute} ${newDaytime}`);
  }

  return (
    <div id="time">
      <Icon icon="clock" />

      <div>
        <input
          type="text"
          id="hours"
          name="hour"
          value={hour}
          maxLength={2}
          onClick={select}
          onKeyDown={handleKeyDown}
          onChange={e => handleChange(e)}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />

        <img src="/assets/media/time.svg" />

        <input
          type="text"
          id="minutes"
          name="minute"
          value={minute}
          maxLength={2}
          onClick={select}
          onKeyDown={handleKeyDown}
          onChange={e => handleChange(e)}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>

      <button id="daytime" className="t-body-s" type="button" onClick={toggleDaytime}>{daytime}</button>
    </div>
  )
}
